import React, { useContext, useEffect, useState } from "react";
import PopupErrorFallback from "./PopupErrorFallback";
import StaticErrorFallback from "./StaticErrorFallback";
import { AuthContext } from "../../Auth/AuthContext";

type ErrorFallbackType = "popup" | "static";

interface FormattedError {
  stack?: string;
  message: string;
}

export interface ErrorFallbackProps {
  error?: Error;
  type?: ErrorFallbackType;
  resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = (props) => {
  const [formattedError, setFormattedError] = useState<FormattedError>(
    {} as FormattedError
  );
  const { error, type, resetErrorBoundary } = props;
  const {
    authState: { user },
  } = useContext(AuthContext);

  useEffect(() => {
    if (error) {
      const errorCopy = {} as FormattedError;
      errorCopy.stack = error.stack;
      errorCopy.message = error.message
        ? error.message
        : "Something went wrong";

      setFormattedError(errorCopy);
    }
  }, [error, user]);

  const retryHandler = () => {
    window.location.reload();
    resetErrorBoundary();
  };

  const homepageHandler = () => {
    window.location.replace("/");
    resetErrorBoundary();
  };

  const getFallbackComponent = () => {
    if (!!formattedError) {
      switch (type) {
        case "popup":
          return (
            <PopupErrorFallback
              error={formattedError}
              onRetry={retryHandler}
              onHomepage={homepageHandler}
            />
          );
        case "static":
          return (
            <StaticErrorFallback
              error={formattedError}
              buttons={[
                {
                  label: "Back to Homepage",
                  onClick: homepageHandler,
                  "data-testid": "error-fallback-homepage-btn",
                },
                {
                  buttonStyle: "primary",
                  label: "Try Again",
                  onClick: retryHandler,
                  "data-testid": "error-fallback-retry-btn",
                },
              ]}
            />
          );
      }
    }
  };

  return getFallbackComponent();
};

export default ErrorFallback;
